import Typed from 'typed.js';
import { useEffect, useRef } from 'react';

const TypedComponent = () => {
  // Create Ref element.
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        'Frontend Developer',
        'Web-Developer',
        'UX/UI Developer',
        'Backend Developer',
      ], // Strings to display
      // Speed settings, try diffrent values untill you get good results
      startDelay: 500,
      typeSpeed: 100,
      backSpeed: 150,
      backDelay: 850,
      loop: true,
      smartBackspace: true,
      showCursor: false,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div>
      <span id="moving-text" ref={el}></span>
    </div>
  );
};

export default TypedComponent;
